module.exports = __webpack_public_path__ + "img/vertical_6_3_6005.ca4a7ad3.png";